import { useContext } from "react";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import get from "@beeldit/core/services/get";
import { DetailsActionContext } from "./DetailsActionContext";

function useGet() {
  const { setElement, setSelectedLang, setCommercePrice } = useContext(DetailsActionContext);
  const errorHandler = useErrorHandler();

  return (
    id: any,
    onSuccess: any = (data: any) => {
      return data;
    }
  ) => {
    get("combinations", id, "?relations=attributes,attributes.options")
      .then((response: any) => {
        let data = response.data;
        data = onSuccess(response.data);
        setCommercePrice(data.price);
        setSelectedLang("es");
        setElement(data);
      })
      .catch((error: any) => {
        errorHandler(error);
      });
  };
}

export default useGet;
